import PropTypes from 'prop-types'

import { MenuButton, ChipPreRegistration } from 'components'
import { TableRow, TableCell } from 'components/Table'

import helpers from 'helpers'
import constants from 'constants/index'

import ActionButtons from '../ActionButtons'

const PreRegistrationsTableRow = ({ preRegistration, refresh }) => {
  return (
    <>
      <TableRow key={preRegistration?.id}>
        <TableCell>{preRegistration?.id}</TableCell>
        <TableCell>{preRegistration?.name}</TableCell>
        <TableCell>
          {preRegistration?.kind === constants.companies.KINDS.PERSONAL
            ? helpers.formatters.cpf(preRegistration?.document)
            : helpers.formatters.cnpj(preRegistration?.document)}
        </TableCell>
        <TableCell>
          {constants.companies.ORIGINS_LABELS[preRegistration?.origin]}
        </TableCell>
        <TableCell disableTooltip>
          <ChipPreRegistration status={preRegistration?.status} />
        </TableCell>
        <TableCell>
          {helpers.formatters.date(preRegistration?.createdAt)}
        </TableCell>
        <TableCell disableTooltip align="right">
          <MenuButton>
            <ActionButtons
              preRegistration={preRegistration}
              refresh={refresh}
              isList
              typeClient={constants.preRegistration.CLIENT_TYPE}
            />
          </MenuButton>
        </TableCell>
      </TableRow>
    </>
  )
}

PreRegistrationsTableRow.propTypes = {
  preRegistration: PropTypes.object,
}

export default PreRegistrationsTableRow
